import React, { useRef } from "react";
import { Col } from "react-bootstrap";
import "../App.css";
import { ReactComponent as GitHubIcon } from "../assets/img/Icons/githubicon.svg";

export const ProjectCard = ({ title, description, imgUrl, link, githubLink, technologies }) => {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = cardRef.current.getBoundingClientRect();
    const x = (e.clientX - left) / width - 0.5;
    const y = (e.clientY - top) / height - 0.5;

    const tilt = 20; // Adjust tilt intensity

    cardRef.current.style.transform = `perspective(1000px) rotateX(${y * tilt}deg) rotateY(${x * tilt}deg) scale(1.04)`;
  };

  const handleMouseLeave = () => {
    cardRef.current.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)";
  };

  return (
    <Col xs={12} sm={6} md={4} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
      <div className="project-card" ref={cardRef}>
        <div className="card-content">
          <div className="card-img" style={{ backgroundImage: `url(${imgUrl})` }}></div>
          <div className="card-text">
            <h4>
              {link ? (
                <a href={link} target="_blank" rel="noopener noreferrer" className="card-title">
                  {title}
                </a>
              ) : (
                <span className="card-title">{title}</span>
              )}
              {githubLink && (
                <a
                  href={githubLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="github-link"
                >
                  <GitHubIcon className="github-icon" />
                </a>
              )}
            </h4>
            <span className="card-description">{description}</span>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default ProjectCard;







